/**
 * Loads the CDLE Common Intake program config. For Phase 0 this is
 * bundled at build time (one hardcoded workflow per ADR-006).
 *
 * The JSON is compiled from YAML by `scripts/build-config.mjs`. Vite
 * handles JSON imports natively — no fetch, no runtime cost beyond the
 * initial SPA bundle.
 */

import rawConfig from '../../config/programs/cdle-common-intake.json';
import type { ProgramConfig, ProgramField } from './types';

// The import is typed as unknown because tsconfig `resolveJsonModule` would
// otherwise infer an over-specific literal type. Cast once here so the rest
// of the SPA can consume the canonical type.
const CONFIG = rawConfig as unknown as ProgramConfig;

export function useProgramConfig(): ProgramConfig {
  return CONFIG;
}

/** Convenience: look up a field definition by key. Returns undefined if the
 *  key isn't in the config (a sign that wire state has drifted from the
 *  bundled config — surfaces in review UIs as "unknown field"). */
export function fieldByKey(
  config: ProgramConfig,
  key: string,
): ProgramField | undefined {
  return config.fields[key];
}
